import React, { useState } from 'react';
import type { Scene } from '../../types';
import { AssetPickerModal } from './AssetPickerModal';
import { InlineBackgroundPanel, type BackgroundSectionToggleProps } from './InlineBackgroundPanel';
import {
  clearSceneBackground,
  hasLocalBackground,
  setSceneBackground,
} from './inline-background-model';
import inline from './inline-editor.module.css';
import type { InlineScenarioChangeOptions } from './use-inline-block-history';

interface InlineBlockBackgroundControlsProps {
  scenarioId: string;
  scene: Scene;
  editMode: boolean;
  onChange: (next: Scene, options?: InlineScenarioChangeOptions) => void;
  sectionToggle?: BackgroundSectionToggleProps;
}

/** Ligne background inline par scène, ou « + Background ». */
export const InlineBlockBackgroundControls: React.FC<InlineBlockBackgroundControlsProps> = ({
  scenarioId,
  scene,
  editMode,
  onChange,
  sectionToggle,
}) => {
  const [pickerOpen, setPickerOpen] = useState(false);
  const isLocal = hasLocalBackground(scene);

  if (isLocal) {
    return (
      <InlineBackgroundPanel
        scenarioId={scenarioId}
        backgroundPath={scene.background!}
        editMode={editMode}
        onPick={(path) =>
          onChange(setSceneBackground(scene, path), { recordBlockHistory: true })
        }
        onRemove={() =>
          onChange(clearSceneBackground(scene), { recordBlockHistory: true })
        }
        sectionToggle={sectionToggle}
      />
    );
  }

  if (!editMode) return null;

  return (
    <div className={inline.bgBlockControls}>
      <button
        type="button"
        className={inline.stageLink}
        onClick={() => setPickerOpen(true)}
        title="Ajouter un background sur cette scène"
      >
        + Background
      </button>
      {pickerOpen && (
        <AssetPickerModal
          scenarioId={scenarioId}
          value=""
          subdir="backgrounds"
          onSelect={(path) => {
            onChange(setSceneBackground(scene, path), { recordBlockHistory: true });
            setPickerOpen(false);
          }}
          onClose={() => setPickerOpen(false)}
        />
      )}
    </div>
  );
};
